import { StatsWidget, StatsWrapper } from './StatsWidget'

export { StatsWidget, StatsWrapper }
